import React, { useState, useEffect } from 'react';

// Components
// ---------------------
import { ClickboxMenu } from '../../../../components/clickbox-menu/clickbox-menu';
import { LoadingSpinner } from '../../../../components/loading-spinner/loading-spinner';

// API
// ---------------------
import { cmsDocumentList } from '../../../../api/api';

export const getTechnicalSpecificationsMenuItems = () => {
  return cmsDocumentList({}, { CmsComponent: 'TechnicalSpecs' });
};

export const TechnicalSpecifications = ({ ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    getTechnicalSpecificationsMenuItems()
      .then((response) => {
        const documents = response.data.documents.map((document) => {
          const params = `cmsId=${document.cmsId}&fileName=${document.meta.title}&componentType=RAW`;
          return {
            item: document.meta.title,
            path: `/sigmaxmtf/downloadDocuments?downloadType=cms&${params}`,
            isDownload: false,
            newTab: true,
          };
        });
        setMenuItems(documents);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <div
      id="technical-specifications"
      aria-labelledby="technical-specifications-navigation-button"
    >
      <LoadingSpinner status={isLoading} name={'Technical Specifications'} />
      <div hidden={isLoading}>
        <ClickboxMenu
          menuItems={menuItems}
          aria={'Technical Specifications Menu'}
        />
      </div>
    </div>
  );
};
